import { commonRequest } from '@/utils/request'
/** 获取单元行为统计 */
export function getNetDevBehavior(params: {
  netId: string,
  date: string,
  groupId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/WeChatData/NetDevBehavior',
    params,
  })
}
/** 获取雷达行为统计 */
export function getNetDevRadarBehavior(params: {
  netId: string,
  date: string,
  groupId: string,
  filter:boolean
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/WeChatData/NetDevRadarBehavior',
    params,
  })
}
/** 获取雷达行为统计 */
export function getNetSmartCurtainBehaviorV3(params: {
  netId: string,
  date: string,
  groupId: string

}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/WeChatData/NetSmartCurtainBehaviorV3',
    params,
  })
}

/** 获取传感器行为统计 */
export function getNetDevSensorBehavior(params: {
  netId: string,
  date: string,
  groupId: string

}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/WeChatData/NetDevSensorBehavior',
    params,
  })
}
/** 获取空调行为统计 */
export function getNetDevAirBehavior(params: {
  netId: string,
  date: string,
  groupId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/NetDevAirBehavior',
    params,
  })
}

/** 获取天气数据 */
export function getWeather(params: {
  orgId: string,
  date: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/DataV/Weather',
    params,
  })
}



/** 获取空气质量传感器行为统计 */
export function getNetDevAirSensorBehavior(params: {
  netId: string,
  date: string,
  groupId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/NetDevAirSensorBehavior',
    params,
  })
}
/** 获取电表功率统计 */
export function getElectricPowerBehavior(data: {
  orgId: string,
  devs: string[]
  date: string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Data/ElectricPowerBehavior',
    data,
  })
}

/** 获取空开数据表格视图 */
export function getSwitchTable(data: {
  start: string,
  end: string,
  netIdGroupIdList: any[]
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Electric/ElectricTable',
    data,
  })
}

/** 导出空开数据表格 */
export function exportSwitchTable(data: {
  start: string,
  end: string,
  netIdGroupIdList: any[]
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Electric/ElectricTableExport',
    responseType: 'blob',
    data,
  })
}

/** 获取传感器行为统计 */
export function getSocketBehavior(params: {
  netId: string,
  date: string,
  groupId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/SocketBehavior',
    params,
  })
}

/** 获取曼顿设备每日数据统计 */
export function getManDunElectricDayBehavior(params: {
  projectCode: string
  mac: string
  year: string
  month: string
  day: string
  hour: string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Electric/GET_BOXES_HOUR_STATS',
    params,
  })
}

export function getElectricBehavior(params: {
  devId: string
  Date: string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Electric/ElectricBehavior',
    params,
  })
}

export function getElectricEnergyBehavior(data: {
  orgId: string,
  devs: string[]
  unit: string
  single: string
  start: string
  end: string
  type: number
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Data/ElectricEnergyBehavior',
    data,
  })
}

export function getElectricEnergyBehavior1(data: {
  orgId: string,
  devs: string[]
  unit: string
  single: string
  start: string
  end: string
  type: number
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Electric/ElectricComplexBehavior',
    data,
  })
}

/** 获取异常统计列表 */
export function getDevExcaptionList(data: {
  pageNum: number,
  pageSize: number,
  arg1: string,
  userName:string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Data/FindPageDevFault',
    data,
  })
}
/** 添加异常 */
export function addDevExcaption(data: {
  devId: string
  content: string
  netId: string
  orgId: string
  uName: string
  upStyle: number
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/DevFault',
    data,
  })
}
/** 批量清除异常统计列表 */
export function deleteDevExcaptions(data: {
  devFaultCleanList: {id: string, solution?: string}[]
}) {
  return commonRequest({
    method: 'PUT',
    url: '/V1/DevFault/Solution/Batch',
    data,
  })
}
/** 统计设备数量 */
export function getDeviceInfo(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/DevCount',
    params,
  })
}
//获取电量统计曲线数据
export function getDevPowerList(params: {
  devId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Electric/DevPowerList',
    params,
  })
}
/** 获取全部设备 */
export function getAllDev(params:string) {
  return commonRequest({
    method: 'get',
    url: '/V1/DevUseablePpe/DevList/'+params,
   
  })
}
/** 统计设备数量 */
export function getElectricInfo(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/User/ElectricInfo',
    params,
  })
}

/** 统计设备运行总时间 */
export function getDeviceCountTime(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/CurrentRunTimeSum',
    params,
  })
}
/** 统计设备日平均运行总时间 */
export function getDeviceAverageTime(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/CurrentRunTimeDayAvg',
    params,
  })
}
/** 获取运行时长 */
export function getRunTimeStats(data: {
  orgId: string
  posIds: string[]
  spaceTypeId?: string
  unit: string
  start: string
  end: string
  type: number
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Data/RunTimeSumCurve',
    data,
  })
}
/** 获取运行时长 */
export function getRunTimeStatsTable(data: {
  orgId: string
  posIds: string[]
  level: string
  start: string
  end: string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Data/CountPosData',
    data,
  })
}
/** 获取组织设备数量 */
export function getDevCounts(params: {
  date: string
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/DevCounts',
    params,
  })
}
/** 获取时间段内netId的开关次数，自动次数，自动率 */
export function getDevAutoCounts(params: {
  netId: string
  date: string
  workTime: string
  beginTime: string
  endTime: string
  invalidTimeBegin: string
  invalidTimeEnd: string

}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/OneDayReport',
    params,
  })
}

export function getDayDevCounts(params: {
  netId: string
  date: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/DayDevCounts',
    params,
  })
}
/** 获取时间段内netId的开关次数，自动次数，自动率 */
export function getNetIdStatisticsData(params: {
  netId: string
  beginDay: string
  endDay:string
  workTime: string
  beginTime: string
  endTime: string
  invalidTimeBegin: string
  invalidTimeEnd: string

}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/MoreDayReport',
    params,
  })
}
